// Disable all auto-scroll behavior globally
(function() {
  'use strict';

  // Override window.scrollTo to prevent auto-scrolling
  const originalScrollTo = window.scrollTo;
  let isUserScroll = false;

  // Track if user is manually scrolling
  let scrollTimeout;
  window.addEventListener('wheel', () => {
    isUserScroll = true;
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      isUserScroll = false;
    }, 1000);
  }, { passive: true });

  window.addEventListener('touchmove', () => {
    isUserScroll = true;
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      isUserScroll = false;
    }, 1000);
  }, { passive: true });

  // Override scrollTo to ignore automatic calls
  window.scrollTo = function(...args) {
    // Only allow scrollTo if user initiated it
    // This prevents auto-scroll from popups, etc.
    // Do nothing - disable all scrollTo calls
  };

  // Also override Element.scrollIntoView
  const originalScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function(...args) {
    // Disable automatic scroll into view
    // Do nothing
  };

  // Disable theme:scroll custom events
  if (window.Shopify && window.Shopify.theme) {
    // Prevent scroll lock/unlock events from triggering
  }

  // Prevent scroll from being triggered on popup open/close
  document.addEventListener('theme:scroll:lock', (e) => {
    e.preventDefault();
    e.stopPropagation();
  }, true);

  document.addEventListener('theme:scroll:unlock', (e) => {
    e.preventDefault();
    e.stopPropagation();
  }, true);

})();
